import { Component, Inject, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NotificationService } from 'src/app/Service/notification.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { StartWFsaveInputModel } from 'src/app/ViewModel/ScheduleDocumentModel';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { CommonService } from "src/app/Service/Common.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { Module } from "src/app/Service/element-details.data.service";
import { MemberElementDetailLinkService } from "src/app/Service/member-element-detail-link/member-element-detail-link.service";
import { EIPMultiSelectAutoCompleteComponent } from "eipmulti-select-auto-complete";

@Component({
    selector: 'app-schedule-startworkflow',
    templateUrl: './schedule-startworkflow.component.html',
    styleUrls: ['./schedule-startworkflow.component.css']
})
export class ScheduleStartWorkflowComponent {
    //roles: FormArray[] = [];
    roleMemberForm: FormGroup = new FormGroup({
        roles: new FormArray([])
    });
    dciToStartWorkflow: any[] = [];
    rolesToStartWorkflow!: any[];
    DciWorkflowStage: any[] = [];
    projectSelectedMembers!: any[];
    disciplineId!: number;
    members: any[] = [];
    gridData: any[] = [];
    CopyAllmember: any[] = [];
    member: any[] = [];
    selectedKey: any[] = [];
    roleID: any[] = [];
    autoSelectKey: any[] = [];
    SelectedID: any[] = [];
    isShowCopyBtn: boolean = false;
    userMappedObject = new Map<string, number[]>();
    discipline!: IProjectElementDetailsOutput[];
    public enableFullscreen: boolean = false;
    @ViewChild('dciToStartWorkflowGrid') grid: any;
    @ViewChildren(EIPMultiSelectAutoCompleteComponent) select!: QueryList<any>;

    constructor(private _notificationService: NotificationService,
        private _scheduleDocService: ScheduleDocumentService, public _workflowTemplateService: WorkflowTemplateService,
        public _dialogRef: MatDialogRef<ScheduleStartWorkflowComponent>,
        public commonService: CommonService,
        private _projService: ProjectInfoService,
        public memberElementDetailLinkService: MemberElementDetailLinkService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.dciToStartWorkflow = this.data.dciToStartWorkflow;
    }

    ngOnInit(): void {
        this.getAllRoleMember();
    }

    closeDialog() {
        this._dialogRef.close();
    }

    get RoleControls() {
        return (<FormArray>this.roleMemberForm.get('roles')).controls;
    }

    async callApis(getDocDiscipline: any[]) {
        let Doc_Discipline: any[] = [];
        this.dciToStartWorkflow.forEach(element => {
            element.DciScheduleElementDetails.forEach((data: { dE_Description: string; }) => {
                if (data.dE_Description == "Discipline") {
                    Doc_Discipline.push(data);
                }
            });
        });
        Doc_Discipline.forEach(element => {
            this.memberElementDetailLinkService.getSelectedMembers(this.commonService.getProjectId(), this.commonService.getLoggedInUserGroupId(), element.dE_Id, element.deD_Id, Module.ScheduleDocument).subscribe((data) => {
                if (!!data) {
                    this.disciplineId = element.deD_Id;
                    this.projectSelectedMembers = data;
                    this.populateGrid(this.projectSelectedMembers);

                }
            })
        });
    }


    async getAllRoleMember(projectSelectedMembers?: any) {
        this.rolesToStartWorkflow = await this._scheduleDocService.GetStartWorkflowDetails(this.dciToStartWorkflow).toPromise();
        this.callApis(this.dciToStartWorkflow);
        window.sessionStorage.setItem("members", JSON.stringify(this.rolesToStartWorkflow));
        this.CopyAllmember = JSON.parse(sessionStorage.getItem("members"));//no brackets
    }

    getmembers(): string {
        let x = sessionStorage.getItem("members");
        return x ? x : "";
    }

    populateGrid(projectSelectedMembers?: any) {

        this.rolesToStartWorkflow = JSON.parse(sessionStorage.getItem("members"));
        let memberCopy: any[] = [];
        memberCopy = this.rolesToStartWorkflow.filter(x => x);
        this.rolesToStartWorkflow = this.rolesToStartWorkflow.filter(x => x.roleId != 0);
        for (let i = 0; i <= this.rolesToStartWorkflow.length; i++) {
            if (this.rolesToStartWorkflow[i].roleMembersMapping.length > 0) {
                if (this.projectSelectedMembers.length > 0) {
                    let Discipline_base_Member = this.rolesToStartWorkflow[i].roleMembersMapping.filter((data: { memberId: any; }) => {
                        return this.projectSelectedMembers.some(member => data.memberId == member.memberId);
                    })
                    if (Discipline_base_Member != 0) {
                        this.rolesToStartWorkflow[i].roleMembersMapping = Discipline_base_Member;
                        this.dciToStartWorkflow.forEach(element => {
                            if (element.DciScheduleElementDetails.some((x: { deD_Id: number; }) => x.deD_Id == this.disciplineId)) {
                                element["roleMembersMapping"] = this.rolesToStartWorkflow;
                            };
                        })
                    } else {
                        this.dciToStartWorkflow.forEach(element => {
                            if (element.DciScheduleElementDetails.some((x: { deD_Id: number; }) => x.deD_Id == this.disciplineId)) {
                                element["roleMembersMapping"] = JSON.parse(sessionStorage.getItem("members"));
                            };
                        })
                    }
                } else {
                    this.dciToStartWorkflow.forEach(element => {
                        if (element.DciScheduleElementDetails.some((x: { deD_Id: number; }) => x.deD_Id == this.disciplineId)) {
                            element["roleMembersMapping"] = JSON.parse(sessionStorage.getItem("members"));
                        };
                    })
                }
            }
            let Dci_lengthCount = this.dciToStartWorkflow.filter(x => !!x.roleMembersMapping);
            if (Dci_lengthCount.length == this.dciToStartWorkflow.length) {
                let stage: any[] = []
                let stageName: any[] = [];
                stage.push(this.dciToStartWorkflow[0]);
                if (this.DciWorkflowStage.length = 1) {
                    stage.forEach(x => {
                        if (!!x.roleMembersMapping) {
                            x.roleMembersMapping.map((y: { roleDescription: any; }) => {
                                if (!!y) {
                                    let obj: any = {};
                                    obj["roleDescription"] = " ";
                                    obj["roleDescription"] = y.roleDescription;
                                    stageName.push(obj)
                                }
                            })
                        }
                    })
                    this.DciWorkflowStage = stageName.filter(x => !!x.roleDescription);
                }
                this.dciToStartWorkflow.forEach(x => {
                    if (!!x.roleMembersMapping) {
                        if (this.members.length != this.dciToStartWorkflow.length) {
                            let obj: any = {};
                            obj["roleMembersMapping"] = [];
                            obj["docId"] = 0;
                            obj["revesion"] = x.revisionNumber;
                            obj["roleMembersMapping"] = x.roleMembersMapping;
                            obj["docId"] = x.documentId;
                            x.roleMembersMapping.forEach((element: any) => {
                                element["DefaultselectedmemberId"] = [];
                                if (element.roleMembersMapping.length == 1) {
                                    let revesion = x.revisionNumber;
                                    let documentId = x.documentId;
                                    let roleId = element.roleId;
                                    let key = `${documentId}_${x.revisionNumber}_${roleId}`;
                                    let obj1 = {
                                        "roleId": roleId,
                                        "key": key
                                    }
                                    this.autoSelectKey.push(obj1);
                                    element["selectedMemberId"] = [];
                                    element.DefaultselectedmemberId.push(element.roleMembersMapping[0].memberId);
                                    element.selectedMemberId.push(element.roleMembersMapping[0].memberId);
                                    this.onChange_Member(null, documentId, revesion, roleId, element.DefaultselectedmemberId,);
                                }
                            });
                            this.members.push(obj);
                            if (this.members.length > 1) {
                                this.isShowCopyBtn = true;
                            }
                            this.members.forEach((data, index) => {
                                data["index"] = index;
                            })
                            this.member = JSON.parse(JSON.stringify(this.members[0].roleMembersMapping));
                            this.member.forEach(data => {
                                data["index"] = 0;
                            })
                        }
                    }
                })
            }
            //  this.gridData = [...this.dciToStartWorkflow];

            if (this.rolesToStartWorkflow[i].roleMembersMapping.length <= 0) {
                this.closeDialog();
                this._notificationService.showToast("'" + this.rolesToStartWorkflow[i].roleDescription + "' role does not mapped to any member(s)", "Warning");
                return;
            }
        }
        this.rolesToStartWorkflow.forEach(x => x.roleMembersMapping);
        for (let i = 0; i < this.rolesToStartWorkflow.length; i++) {
            let _role = this.rolesToStartWorkflow[i];
            this.RoleControls.push(new FormControl('', [Validators.required]));
            _role.formControl = this.RoleControls[i];
        }
    }

    onChange_Member(event: { emittingList: any[]; } | null, documentId: any, revisionNumber: any, roleId: any, defaultselectedMemberId?: any[], roleDescription?: any, index?: any, type?: any) {
        let key = `${documentId}_${revisionNumber}_${roleId}`;
        if (this.userMappedObject.has(key))
            this.userMappedObject.delete(key);
        let selectedMemberIds: number[] = [];
        if (!!event) {
            selectedMemberIds = event.emittingList.map(x => x.value);
            let obj = {
                "roleId": roleId,
                "key": key
            }
            this.selectedKey.push(obj);
            this.selectedKey = this.getUnique(this.selectedKey, 'key');
        }
        if (!!defaultselectedMemberId)
            selectedMemberIds = defaultselectedMemberId.map(Id => Id);

        if (selectedMemberIds.length == 0 && type == 'manual') {
            let obj = {
                "roleId": roleId,
                "key": key
            }
            this.roleID.push(obj);
            this.roleID = this.getUnique(this.roleID, 'key');
        }
        this.userMappedObject.set(key, selectedMemberIds);
        let selectedID = Array.from(this.userMappedObject.values());
        let SelectedID = selectedID.pop();
        if (roleDescription) {
            this.getMemberValue(roleDescription, SelectedID, index)
        }
    }


    getMemberValue(roleDescription: any, SelectedID: any, index?: any) {
        // copy everything from original    
        this.member.forEach(element => {
            if (element.roleDescription == roleDescription && index == element.index) {
                element["DefaultselectedmemberId"] = SelectedID;
            }
        })
    }



    copyMembers() {
        this.member.forEach((val, i) => {
            this.members.forEach(element => {
                element.roleMembersMapping.forEach((data: { [x: string]: any; roleDescription: any; roleId: any; }) => {
                    if (data.roleDescription == val.roleDescription) {
                        this.select.forEach((component, i) => {
                            if (component.setId == data.roleId) {
                                if (val.DefaultselectedmemberId.length > 0) {
                                    component.emittedList = [];
                                    this.onChange_Member(null, element.docId, element.revesion, data.roleId, val.DefaultselectedmemberId, data.roleDescription, element.index)
                                    component.selCountText = "Selected Count : " + val.DefaultselectedmemberId.length;
                                } else {
                                    if (this.roleID.length > 0) {
                                        this.roleID.forEach(obj => {
                                            if (obj.roleId == component.setId) {
                                                component.clearValue = "Y";
                                            }
                                            if (this.selectedKey.length > 0) {
                                                this.selectedKey.forEach(x => {
                                                    if (obj.roleId == x.roleId) {
                                                        if (this.userMappedObject.has(x.key)) {
                                                            this.userMappedObject.delete(x.key);
                                                        }
                                                    }
                                                })
                                            }
                                            if (this.autoSelectKey.length > 0) {
                                                this.autoSelectKey.forEach(obj2 => {
                                                    if (obj.roleId == obj2.roleId) {
                                                        if (this.userMappedObject.has(obj2.key)) {
                                                            this.userMappedObject.delete(obj2.key);
                                                        }
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }
                            }
                        })
                        data["selectedMemberId"] = val.DefaultselectedmemberId;
                    }
                });
            })
        })
    }

    getUnique(arr: any[], comp: string) {
        // store the comparison  values in array
        const unique = arr.map(e => e[comp])
            // store the indexes of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)
            // eliminate the false indexes & return unique objects
            .filter((e: any) => arr[e]).map((e: any) => arr[e]);
        return unique;
    }

    onClick_Save() {
        if (this.userMappedObject.size <= 0) {
            this._notificationService.showToast("Member selection is mandatory for all the roles", "Warning");
            return;
        }
        let uniqueRolesMapped: any[] = [];
        let memberInput: StartWFsaveInputModel[] = [];
        this.userMappedObject.forEach((memberIds, key) => {
            let splitData = key.split('_');
            let docId: number = Number(splitData[0]);
            let revNo: string = splitData[1].toString();
            let roleId: number = Number(splitData[2]);

            if (uniqueRolesMapped.filter(y => y == roleId).length == 0)
                uniqueRolesMapped.push(roleId);

            memberIds.forEach(memberId => {
                memberInput.push(this.convertData(docId, revNo, roleId, memberId));
            })
        });


        if (this.userMappedObject.size == 0 && memberInput.length == 0) {
            this.dciToStartWorkflow.forEach((data) => {
                memberInput.push(this.convertData(data.documentId, data.revisionNumber, 0, 0));
            });
        }

        for (let i = 0; i < this.dciToStartWorkflow.length; i++) {
            let currentDocument = this.dciToStartWorkflow[i].documentId;
            let rolesForCurrentDocument = memberInput.filter(x => x.documentId == currentDocument);
            const distinctThings = rolesForCurrentDocument.filter(
                (thing, i, arr) => arr.findIndex(t => t.roleId === thing.roleId) === i
            );

            if (this.rolesToStartWorkflow.length != distinctThings.length) {
                this._notificationService.showToast("Member selection is mandatory for all the roles", "Warning");
                return;
            }
        }
        if (memberInput.length > 0) {
            this._notificationService.showPopup('Are you sure to start workflow for the selected Document(s)?', 'Confirm').then(data => {
                if (data == 'yes') {
                    this._scheduleDocService.PostStartWorkflowDetails(this.dciToStartWorkflow, memberInput).subscribe((data) => {
                        if (data["successCode"] === 200) {
                            this._notificationService.showToast(data["successMessage"], "Success")
                            this._dialogRef.close();
                        }
                        else {
                            this._notificationService.showToast(data["successMessage"], "Warning")
                        }
                    });
                }
            });
        }
    }

    convertData = (documentId: number, revisionNumber: string, roleId: number, memberId: number) => ({ documentId, revisionNumber, roleId, memberId })

    onClick_Reset() {
        this._notificationService.showPopup('Are you sure to reset the selected value(s)?', 'Confirm').then(data => {
            if (data == 'yes') {
                this.members = [];
                this.userMappedObject.clear();
                this.populateGrid();
            }
        });
    }

}